import React, { useEffect, useState, useRef } from 'react'
import { Modal, Button, Table, Pagination, Spinner } from 'react-bootstrap'
import apinode from '../../services/apinode.js'
import './complete-match.css'
import { BiSearch } from 'react-icons/bi'
import { FaCheck, FaImage } from 'react-icons/fa'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

function AutocompleteProdutoMatch(props) {
  const [texto, setTexto] = useState('')
  const [lista_clientes, setListaClientes] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [composicoes, setComposicoes] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [paginaAtual, setPaginaAtual] = useState(1)

  const inputRef = useRef(null)
  const modalRef = useRef(null)
  const controllerRef = useRef(null)

  const itensPorPagina = 30

  const montarUrlImagem = (img) => {
    if (!img) return null
    if (img.startsWith('http://') || img.startsWith('https://')) return img
    return `https://node.ziphub.com.br/imagens/${img}`
  }

  const fecharModal = () => {
    controllerRef.current?.abort()
    setShowModal(false)
    setListaClientes([])
    setPaginaAtual(1)
    setTexto('')
    setComposicoes({})
    setIsLoading(false)
  }

  const buscarComposicoes = async (SKU) => {
    try {
      const response = await apinode.get(
        `/custos/listacomposicao/${SKU}/${localStorage.idconta}`,
      )
      return response.data
    } catch (error) {
      console.error('Erro ao buscar composições:', error)
      return []
    }
  }

  const PesquisarClientes = async (busca) => {
    controllerRef.current?.abort()
    controllerRef.current = new AbortController()

    setShowModal(true)
    setIsLoading(true)

    try {
      const response = await apinode.get('estoque/listaproduto', {
        params: {
          sku: busca.trim(),
          conta: localStorage.idconta,
        },
        signal: controllerRef.current.signal,
      })

      setListaClientes(response.data)
      setPaginaAtual(1)

      const composicoesPromises = response.data.map(async (cli) => {
        try {
          const comps = [] /* await buscarComposicoes(cli.SKU) */
          return { SKU: cli.SKU, composicoes: comps }
        } catch {
          return { SKU: cli.SKU, composicoes: [] }
        }
      })

      const composicoesResults = await Promise.all(composicoesPromises)
      const composicoesObj = composicoesResults.reduce((acc, curr) => {
        acc[curr.SKU] = curr.composicoes
        return acc
      }, {})

      setComposicoes(composicoesObj)
    } catch (err) {
      if (err.name !== 'CanceledError') {
        console.error(err)
      }
    } finally {
      setIsLoading(false)
    }
  }

  const Filtrar = () => {
    if (texto.trim().length > 2) {
      PesquisarClientes(texto)
    }
  }

  const selecionarItem = (id, nome, cod, vlr, custo, img, comissao_produto) => {
    setTexto(nome)
    props.onClickId(id)
    props.onClickNome(nome)
    props.onClickProdInterno(cod)
    props.OnClickValor(vlr)
    props.ClickTexto(nome)
    props.OnClickCusto(custo)
    props.OnClickImg(img)
    props.OnClickComissaoProduto(comissao_produto)
    fecharModal()
  }

  const Clear = () => {
    setTexto('')
    props.onClickId(0)
    props.onClickNome('')
    props.onClickProdInterno('')
    props.OnClickValor('')
    props.OnClickCusto('')
    props.OnClickImg('')
    props.OnClickComissaoProduto('')
    setListaClientes([])
  }

  const totalPaginas = Math.ceil(lista_clientes.length / itensPorPagina)
  const clientesPagina = lista_clientes.slice(
    (paginaAtual - 1) * itensPorPagina,
    paginaAtual * itensPorPagina,
  )

  const mudarPagina = (num) => {
    if (num < 1 || num > totalPaginas) return
    setPaginaAtual(num)
  }

  const renderizarPaginacao = () => {
    if (totalPaginas <= 1) return null
    const delta = 2
    const itens = []

    itens.push(
      <Pagination.Prev
        key="prev"
        onClick={() => mudarPagina(paginaAtual - 1)}
        disabled={paginaAtual === 1}
      />,
    )

    for (
      let i = Math.max(1, paginaAtual - delta);
      i <= Math.min(totalPaginas, paginaAtual + delta);
      i++
    ) {
      itens.push(
        <Pagination.Item
          key={i}
          active={i === paginaAtual}
          onClick={() => mudarPagina(i)}
        >
          {i}
        </Pagination.Item>,
      )
    }

    itens.push(
      <Pagination.Next
        key="next"
        onClick={() => mudarPagina(paginaAtual + 1)}
        disabled={paginaAtual === totalPaginas}
      />,
    )

    return <Pagination>{itens}</Pagination>
  }

  useEffect(() => {
    setTexto(props.value || '')
  }, [props.value])

  return (
    <div className="autocomplete">
      {/* Input e Botões */}
      <div
        className="autocomplete d-flex align-items-center position-relative"
        ref={inputRef}
      >
        <input
          type="text"
          className="form-control flex-grow-1 mr-2"
          placeholder={props.placeholder}
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && Filtrar()}
          style={{
            fontSize: '11px',
            paddingRight: '40px',
            height: '38px',
            minWidth: '300px',
          }}
        />
        <button
          className="btn btn-primary"
          onClick={Filtrar}
        >
          {isLoading ? (
            <Spinner
              animation="border"
              size="sm"
            />
          ) : (
            <BiSearch />
          )}
        </button>
        {texto.length > 0 && (
          <button
            className="btn btn-light autocomplete-clear"
            onClick={Clear}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        )}
      </div>

      {/* Modal */}
      <Modal
        show={showModal}
        onHide={fecharModal}
        size="lg"
        dialogClassName="custom-modalzpl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Pesquisa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={modalRef}>
            {isLoading && lista_clientes.length === 0 ? (
              <div className="text-center py-4">
                <Spinner animation="border" />
                <p className="mt-2">Carregando produtos...</p>
              </div>
            ) : lista_clientes.length > 0 ? (
              <>
                <Table
                  striped
                  hover
                  responsive
                  className="table-products-search text-center"
                >
                  <thead>
                    <tr>
                      <th></th>
                      <th>Produto</th>
                      <th>SKU</th>
                      <th>Cod.</th>
                      <th>EAN</th>
                      <th>Custo</th>
                      <th>Preço</th>
                      <th>Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clientesPagina.map((cli) => (
                      <React.Fragment key={cli.SKU}>
                        <tr
                          onClick={() =>
                            selecionarItem(
                              cli.SKU,
                              cli.DESCRICAO,
                              cli.CODPRODUTO,
                              cli.PRECOVENDA,
                              cli.PRECOCUSTO,
                              montarUrlImagem(cli.IMG_CAPA),
                              cli.COMISSAO_SOBRE_PRODUTO,
                            )
                          }
                          style={{ cursor: 'pointer' }}
                        >
                          <td>
                            {montarUrlImagem(cli.IMG_CAPA) ? (
                              <img
                                src={montarUrlImagem(cli.IMG_CAPA)}
                                alt={cli.DESCRICAO}
                                style={{
                                  width: 50,
                                  height: 50,
                                  objectFit: 'contain',
                                }}
                              />
                            ) : (
                              <FaImage
                                style={{ fontSize: 24, color: '#ccc' }}
                              />
                            )}
                          </td>
                          <td>
                            {cli.DESCRICAO}{' '}
                            <small className="text-muted">
                              ({cli.QTESTGER})
                            </small>
                          </td>
                          <td>{cli.SKU}</td>
                          <td>{cli.CODPRODUTO}</td>
                          <td>{cli.CODBARRAS}</td>
                          <td>
                            {localStorage.admin === 'SIM'
                              ? Number(cli.PRECOCUSTO || 0).toLocaleString(
                                  'pt-BR',
                                  {
                                    style: 'currency',
                                    currency: 'BRL',
                                  },
                                )
                              : '-'}
                          </td>
                          <td>
                            {Number(cli.PRECOVENDA || 0).toLocaleString(
                              'pt-BR',
                              {
                                style: 'currency',
                                currency: 'BRL',
                              },
                            )}
                          </td>
                          <td>
                            <Button
                              variant="primary"
                              size="sm"
                            >
                              Selecionar
                            </Button>
                          </td>
                        </tr>

                        {(composicoes[cli.SKU] || []).map((itemComposicao) => (
                          <tr
                            key={itemComposicao.sku}
                            className="table-light"
                            onClick={() =>
                              selecionarItem(
                                itemComposicao.sku,
                                itemComposicao.descricao,
                                itemComposicao.codproduto,
                                itemComposicao.precovenda,
                                itemComposicao.precocusto,
                                montarUrlImagem(itemComposicao.img_capa),
                              )
                            }
                          >
                            <td>
                              {montarUrlImagem(itemComposicao.img_capa) ? (
                                <img
                                  src={montarUrlImagem(itemComposicao.img_capa)}
                                  alt={itemComposicao.descricao}
                                  style={{
                                    width: 50,
                                    height: 50,
                                    objectFit: 'contain',
                                  }}
                                />
                              ) : (
                                <FaImage
                                  style={{ fontSize: 24, color: '#ccc' }}
                                />
                              )}
                            </td>
                            <td>
                              {itemComposicao.descricao}{' '}
                              <small className="text-muted">
                                ({itemComposicao.qtestger})
                              </small>
                            </td>
                            <td>{itemComposicao.sku}</td>
                            <td></td>
                            <td></td>
                            <td>
                              {localStorage.admin === 'SIM'
                                ? Number(
                                    itemComposicao.precocusto || 0,
                                  ).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                  })
                                : '-'}
                            </td>
                            <td>
                              {Number(
                                itemComposicao.precovenda || 0,
                              ).toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </td>
                            <td>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={(e) => {
                                  e.stopPropagation()
                                  selecionarItem(
                                    itemComposicao.sku,
                                    itemComposicao.descricao,
                                    itemComposicao.codproduto,
                                    itemComposicao.precovenda,
                                    itemComposicao.precocusto,
                                    montarUrlImagem(itemComposicao.img_capa),
                                  )
                                }}
                              >
                                <FaCheck />
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </React.Fragment>
                    ))}
                  </tbody>
                </Table>
                {renderizarPaginacao()}
              </>
            ) : (
              <p>Nenhum resultado encontrado.</p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={fecharModal}
          >
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default AutocompleteProdutoMatch
